import { css } from 'styled-components';
const imageStyles = css`
  height: 70px !important;
  width: 70px !important;
  margin-right: 20px !important;
`;
export default imageStyles;
